import { getDomainHost } from 'core/utils';
import { PLAIN_HOMEPAGE_INSTANCES } from 'home/constants';

export const isPlainHomepageInstance = () => {
  return PLAIN_HOMEPAGE_INSTANCES.includes(getDomainHost());
};
